import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";

const KEY = "hgb-cookie-consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-3 left-3 right-3 z-[70] mx-auto max-w-[1100px] rounded-[1.5rem] border border-[#DCCDB4]/25 bg-[#17251C]/95 px-5 py-4 backdrop-blur-xl md:bottom-6 md:px-8"
        >
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <p className="max-w-2xl text-xs leading-relaxed text-[#DCCDB4]">
              Wir verwenden ausschließlich technisch notwendige Cookies. Kein Tracking, keine Analyse. Mehr dazu in der{" "}
              <Link to="/datenschutz" className="font-semibold text-[#93A387] underline">
                Datenschutzerklärung
              </Link>
              .
            </p>
            <div className="flex shrink-0 items-center gap-4">
              <button
                type="button"
                data-testid="cookie-consent-decline-btn"
                onClick={() => decide("essential")}
                className="text-[0.66rem] font-bold uppercase tracking-[0.2em] text-[#93A387] transition-colors hover:text-[#F3EDE2]"
              >
                Nur notwendige
              </button>
              <button
                type="button"
                data-testid="cookie-consent-accept-btn"
                onClick={() => decide("all")}
                className="btn-primary !bg-[#DCCDB4] !px-6 !py-3 !text-[0.62rem] !text-[#17251C] hover:!bg-[#B4623C] hover:!text-[#F3EDE2]"
              >
                Akzeptieren
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
